export default "__VITE_ASSET__BY3V3HoP__"